import React from 'react';
import {
  ProfileTabButton,
  ProfileTabContainer,
} from 'src/mentor/components/MentorProfilePage/MentorProfilePageStyles';

export default function StyledComponentTabs({
  tabs = [],
  value,
  onChange,
  containerClassName = '',
  containerStyle = {},
  textWhiteAlways = false,
}) {
  return (
    <ProfileTabContainer className={containerClassName} style={containerStyle}>
      {tabs.map(({ id, title, icon: Icon }) => (
        <ProfileTabButton
          key={id}
          whiteColorAlways={textWhiteAlways}
          selected={id === value}
          onClick={() => onChange(id)}
          pageValue={id}
        >
          {Icon && <Icon style={{ marginRight: 4, verticalAlign: 'middle' }} />}
          {title}
        </ProfileTabButton>
      ))}
    </ProfileTabContainer>
  );
}
